
import api from "~api";

import XHeader from 'vux/src/components/x-header/index.vue'

import { mapState} from 'vuex'
export default {
components: {
XHeader,
},
computed: mapState({
stu_num: (state) => state.stu_num,
}),
data () {
return {
resData_a:{},
flowdata:[






























],
allflag:false,
title: "新生在线报到"
}
},
/*computed: {
allflag: function () {
let total = false;
this.flowdata.forEach(function (item) {
total =total && item.okflag;
})
return total
}
},
watch: {
flowdata: {
handler: function (newValue, oldValue) {

console.log(newValue)
},
deep: true
}
},*/




methods: {
getData(){
api.post("/api/proces/findProcess", {"stuCode": window.localStorage.getItem("stuCode"),"enrollType": window.localStorage.getItem("enrollType")}).then( res=>{
if(res.status==200){
for(var i=0;i<res.data.results.length;i++){
var item = {
"sort":res.data.results[i].processId,
"title":res.data.results[i].moduleName,
"urlname":res.data.results[i].urlName,
"skip":res.data.results[i].skip
}
if(res.data.results[i].newStatus=='0'){
item["okflag"] = false;
}else{
item["okflag"] = true;
}

if( window.localStorage.getItem('grade')==(new Date().getFullYear()).toString()){
window.localStorage.setItem('newstudent', true)
this.flowdata.push(item);
}else{
window.localStorage.setItem('newstudent', false)
this.title = "线上缴费";
if(res.data.results[i].moduleName==='缴费信息') {
this.flowdata.push(item)
}else if(res.data.results[i].moduleName==='缴费详情') {
this.flowdata.push(item)
}









}
window.localStorage.setItem('flowdata', JSON.stringify(this.flowdata))
}

}
})
},
goto (item,index) {
var _this = this;
var stunum = window.localStorage.getItem('stunum');
if(index==0){
_this.$router.push({name: item.urlname, params:{sort:item.sort,stunum:stunum,skip:item.skip,okflag:item.okflag}});
}else{
if(item.okflag==true || (item.okflag==false && this.flowdata[index-1].okflag==true)){
_this.$router.push({name: item.urlname, params:{sort:item.sort,stunum:stunum,skip:item.skip,okflag:item.okflag}});
}
}
},


getReport(){
var _this = this;
_this.$router.push({name: 'report'});

}


},
created(){
window.localStorage.setItem('stunum', this.$route.params.stunum)
this.getData()
},

}



// WEBPACK FOOTER //
// ./src/components/newstu/welcome.vue